export const ADD_ITEM = 'ADD_ITEM';
export const ADD_ITEMS = 'ADD_ITEMS';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_CART_NOTE = 'SET_CART_NOTE';
export const SET_PRODUCT_ID = 'SET_PRODUCT_ID';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const ADD_UPSELL = 'ADD_UPSELL';
export const REMOVE_UPSELL = 'REMOVE_UPSELL';

export const CartItemsReducer = (state, action) => {
	switch (action.type) {
		case SET_ITEMS:
			return { ...state, items: action.items };
		case SET_CART_NOTE:
			return { ...state, cartNote: action.cartNote };
		case ADD_ITEM:
			return { ...state, items: [action.item].concat(state.items) };
		case ADD_ITEMS:
			return { ...state, items: action.item.concat(state.items) };
		case SET_PRODUCT_ID:
			return { ...state, product_id: action.product_id };
		case SET_CAMPAIGN:
			return { ...state, campaign: action.campaign };
		case ADD_UPSELL:
			const newUpsells = [...new Set([...state.fbtUpsells, action.id])];
			localStorage.setItem('monster_uc_upsells', JSON.stringify(newUpsells));
			return { ...state, fbtUpsells: newUpsells };
		case REMOVE_UPSELL:
			const finalUpsells = state.fbtUpsells.filter((variant_id) => variant_id !== action.id);
			localStorage.setItem('monster_uc_upsells', JSON.stringify(finalUpsells));
			return { ...state, fbtUpsells: finalUpsells };
		default:
			return state;
	}
};
